module.exports = __webpack_public_path__ + "static/media/icon-randomize--active.2ebb3f1e.svg";